import type { ReactNode } from 'react';
import { Col } from '../../col';
import { Row } from '../../row';
import { Text } from '../../typography';

export type HorizontalScrollProperties = {
  className?: string;
  items: ScrollItem[];
  title?: ReactNode;
};

type ScrollItem = {
  content: ReactNode;
  key: string;
};

const HorizontalScroll = ({ className, items, title }: HorizontalScrollProperties) => (
  <Row gutter={[0, 'ms']}>
    {title ? (
      <Col span={24}>
        {typeof title === 'string' ? (
          <Text size="small" type="title" uppercase weight="medium">
            {title}
          </Text>
        ) : (
          title
        )}
      </Col>
    ) : null}
    <Col span={24}>
      <Row className={className} wrap={false}>
        {items.map((item) => (
          <Col alignItems="flexStart" justifyContent="center" key={item.key} span={7}>
            {item.content}
          </Col>
        ))}
      </Row>
    </Col>
  </Row>
);

export default HorizontalScroll;
